<template>
    <Breadcrumbs main="Users" mains="Profile" title="Account" />
    <div class="row justify-content-center">
        <!-- Profile Info Column -->
        <div class="col-md-6">
            <div class="card p-4">
                <div class="text-center mb-4">
                    <img
                        :src="avatarurl || 'https://via.placeholder.com/120'"
                        alt="Profile Picture"
                        class="rounded-circle"
                        width="120"
                        height="120"
                    />
                </div>
                <h4 class="text-center mb-2">{{ name }}</h4>
                <p class="text-center text-muted mb-4">{{ email }}</p>
                <form @submit.prevent="updateProfile">
                    <div class="mb-2">
                        <label class="form-label col-form-label">Name</label>
                        <input v-model="name" type="text" class="form-control" />
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Username</label>
                        <input :disabled="true" v-model="username" type="username" class="form-control" />
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Avatar URL</label>
                        <input v-model="avatarurl" type="text" class="form-control" />
                    </div>
                    <button type="submit" class="btn btn-primary w-100">Update Profile</button>
                </form>
                <!-- Change Password Form -->
                <hr class="my-4" />
                <form @submit.prevent="changePassword">
                    <h5 class="mb-2">Ubah Password</h5>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Password Baru</label>
                        <input v-model="newPassword" type="password" class="form-control" />
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Konfirmasi Password Baru</label>
                        <input v-model="confirmPassword" type="password" class="form-control" />
                    </div>
                    <div v-if="passwordMessage" class="alert" :class="{'alert-success': passwordSuccess, 'alert-danger': !passwordSuccess}">
                        {{ passwordMessage }}
                    </div>
                    <button type="submit" class="btn btn-warning w-100">Ubah Password</button>
                </form>
            </div>
        </div>
        <!-- Awards Column -->
        <div class="col-md-6">
            <div class="card p-4">
                <h5 class="mb-2">Daftar Penghargaan</h5>
                <ul v-if="awards.length > 0" class="list-group">
                    <li v-for="(award, idx) in awards" :key="idx" class="list-group-item">
                        {{ award }}
                    </li>
                </ul>
                <div v-else class="text-muted">Belum ada penghargaan.</div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
const userString = localStorage.getItem('user');
let user = userString ? JSON.parse(userString) : null;
let name = ref(user?.nickname || '');
let email = ref(user?.email || '');
let username = ref(user?.username || '');
let avatarurl = ref(user?.avatarurl || '');
// Add awards ref
let awards = ref(user?.awards || []);

function updateProfile() {
    const updatedUser = {
        ...user,
        nickname: name.value,
        email: email.value,
        avatarurl: avatarurl.value,
        awards: awards.value,
    };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    user = updatedUser;
    // Optionally, show a success message or trigger a UI update
}
let newPassword = ref('');
let confirmPassword = ref('');
let passwordMessage = ref('');
let passwordSuccess = ref(false);

function changePassword() {
    // For demonstration, assume user.password exists in localStorage
    if (!user || !user.password) {
        passwordMessage.value = 'Password lama tidak tersedia.';
        passwordSuccess.value = false;
        return;
    }
    if (newPassword.value !== confirmPassword.value) {
        passwordMessage.value = 'Konfirmasi password baru tidak cocok.';
        passwordSuccess.value = false;
        return;
    }
    if (!newPassword.value) {
        passwordMessage.value = 'Password baru tidak boleh kosong.';
        passwordSuccess.value = false;
        return;
    }
    user.password = newPassword.value;
    localStorage.setItem('user', JSON.stringify(user));
    passwordMessage.value = 'Password berhasil diubah.';
    passwordSuccess.value = true;
    newPassword.value = '';
    confirmPassword.value = '';
}
</script>
